(function () {
  const instances = new Map();

  function init(section) {
    const sectionId = section.dataset.sectionId;
    if (instances.has(sectionId)) return;

    /* ===============================
       Switch bundle logic
    =============================== */

    function switchBundle(blockId) {
      section.querySelectorAll('.lb-selector-pill').forEach((btn) => {
        btn.classList.toggle(
          'is-active',
          btn.dataset.bundleId === blockId
        );
      });

      section.querySelectorAll('.lb-bundle-pane').forEach((pane) => {
        const isActive = pane.dataset.id === blockId;
        pane.classList.toggle('is-visible', isActive);
        pane.classList.toggle('is-hidden', !isActive);
      });

      section.querySelectorAll('.lb-img-canvas').forEach((img) => {
        const isActive = img.dataset.imgId === blockId;
        img.classList.toggle('is-visible', isActive);
        img.classList.toggle('is-hidden', !isActive);
      });
    }

    /* ===============================
       Click handlers
    =============================== */

    section.querySelectorAll('[data-bundle-id]').forEach((btn) => {
      btn.addEventListener('click', () => {
        switchBundle(btn.dataset.bundleId);
      });
    });

    section.querySelectorAll('[data-native-id]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const nativeButton = section.querySelector(
          `#${trigger.dataset.nativeId}`
        );
        if (nativeButton) nativeButton.click();
      });
    });

    instances.set(sectionId, true);
  }

  document.addEventListener(
    'section:lifebeat-bundle-variants:load',
    (e) => {
      init(e.detail);
    }
  );
})();
